import angular from 'angular';

export default angular
	.module('ui.cian.utils.modelToNumber', [])
	.directive('cianUtilsModelToNumber', () => {
		return {
			priority: 2,
			restrict: 'A',
			require: 'ngModel',
			link: (scope, element, attrs, ngModel) => {
				const convertToNumber = num => {
					num = String(num);
					if (num.length === 0) {
						return null;
					}
					num = num.replace(',', '.');
					num = num.replace(/\s/g, '');
					const numParts = num.split('.');
					if (numParts[1]) {
						numParts[1] = numParts[1].substring(0, 2);
						num = numParts.join('.');
					}
					num = isNaN(num) ? undefined : Number(num);
					return num;
				};
				ngModel.$parsers.push(convertToNumber);
				ngModel.$formatters.push(input => {
					const inputNumber = Number(input);
					return angular.isNumber(inputNumber) && input !== null && input !== '' ? inputNumber : null;
				}); // prevent 0 in input field
				if (attrs.maxlength) {
					ngModel.$validators.maxlength = modelValue => modelValue ? String(modelValue).length <= attrs.maxlength : true;
				}

				// convert to number initial value
				scope.$applyAsync(() => {
					if (!isNaN(ngModel.$modelValue) && ngModel.$modelValue !== null && ngModel.$modelValue !== '') {
						ngModel.$setViewValue(Number(ngModel.$modelValue));
					}
				});
			}
		};
	})
	.name;
